document.addEventListener('change', function(event) {
  const input = event.target;
  if (!input.matches('input.custom-file-input[type="file"]')) return;

  const label = input.nextElementSibling;
  if (label) label.textContent = Array.from(input.files, file => file.name).join(', ');
});
